(function () {
  'use strict';

  angular
      .module('tfc.retailer.Brand')
      .controller('BrandAffinityCtrl', BrandAffinityCtrl)
      .constant('BrandDisplaySize', 250);

  // @ngInject
  function BrandAffinityCtrl($state, $scope, $filter, PageSize, BrandAffinityTimeFrames, reportData, $stateParams,
                             focusHierarchies, affinityHierarchies, pricePointData, brands, itemCount, $timeout,
                             translateFilter, BrandAffinityReport, BrandDisplaySize, CookieJar, filters, GaUtil,
                             aggregationLogDetails, Filter) {
    var vm = this;
    vm.brands = _.isArray(brands) ? brands : [];
    vm.selectedBrand = _.find(vm.brands, {key: $stateParams.brandKey});
    vm.timeFrames = BrandAffinityTimeFrames;
    vm.unfilteredData = reportData && reportData.relatedBrands;
    vm.filteredText = "";
    vm.pricePointData = pricePointData;
    vm.itemCount = itemCount;
    vm.pageSize = PageSize;
    vm.totalCount = vm.unfilteredData ? vm.unfilteredData.length : 0;
    vm.filteredCount = vm.totalCount;
    vm.currentPage = $stateParams.pageNumber;
    vm.maxSize = 7;
    vm.options = {
      horizontal : true,
      horizontalLabelSize : 40,
      verticalLabelSize : 15,
      dashedLabelBoxes : true,
      barSpacing : .3,
      disableBar : true,
      labelSize: 240
    };
    vm.focusHierarchies= _(focusHierarchies).map(function(o){
      return {
        focusDepartment: o.department,
        focusCategory: o.category,
        display: o.category ? o.department + "/" + o.category : o.department
      }
    }).value();

    vm.aggregationDetails = aggregationLogDetails;

    vm.affinityHierarchies= _(affinityHierarchies).map(function(o){
      return {
        affinityDepartment: o.department,
        affinityCategory: o.category,
        display: o.category ? o.department + "/" + o.category : o.department
      }
    }).value();

    vm.gaUtil = GaUtil;

    vm.isHierarchyNullOrEmpty = function (hierarchy, isFocus) {
      if (isFocus) {
        return hierarchy.focusDepartment == null || _.trim(hierarchy.focusDepartment) === '';
      }
      else return hierarchy.affinityDepartment == null || _.trim(hierarchy.affinityDepartment) === '';
    };

    vm.clean = function(hierarchies, isFocus) {
      _.remove(hierarchies, function(hierarchy) {
        return vm.isHierarchyNullOrEmpty(hierarchy, isFocus);
      });
    };

    vm.clean(vm.focusHierarchies, true);
    vm.clean(vm.affinityHierarchies, false);

    var ANY_DEPARTMENT = translateFilter('reports.brand.anydepartment');
    vm.focusHierarchies.unshift({ display : ANY_DEPARTMENT });
    vm.affinityHierarchies.unshift({ display : ANY_DEPARTMENT });

    vm.findInHierarchies = function(hierarchies, isFocus, department, category) {
      if (isFocus)
        return _.find(hierarchies, function(hierarchy) {return  (hierarchy.focusDepartment === department && (hierarchy.focusCategory === category || (!category && hierarchy.focusCategory === '')))});
      else
        return _.find(hierarchies, function(hierarchy) {return (hierarchy.affinityDepartment === department && (hierarchy.affinityCategory === category || (!category && hierarchy.affinityCategory ==='')))});
    };

    vm.selectedFocusHierarchy = ($stateParams.focusDepartment == null ? vm.focusHierarchies[0] :  vm.findInHierarchies(vm.focusHierarchies, true, $stateParams.focusDepartment, $stateParams.focusCategory)) || vm.focusHierarchies[0];
    vm.selectedAffinityHierarchy = ($stateParams.affinityDepartment == null ? vm.affinityHierarchies[0] : vm.findInHierarchies(vm.affinityHierarchies, false, $stateParams.affinityDepartment, $stateParams.affinityCategory)) || vm.affinityHierarchies[0];
    vm.selectedTimeFrame = $stateParams.timeFrame;
    vm.seriesFields = ['itemPercent', 'salesPercent'];
    vm.selectedSeries = vm.seriesFields[0];

    vm.activityRegionFilters = filters;

    var selectedTransaction = vm.activityRegionFilters && vm.activityRegionFilters.getSelected();
    var selectedRegion = selectedTransaction && selectedTransaction.getSelectedRegion();

    vm.selectActivityAndReload = function(activity){
      selectedTransaction = activity;
      vm.gaUtil.sendGaEvent(vm.selectedBrand.key, 'Activity Filter', activity.label);
      vm.reload(false, false);
    };

    vm.selectRegionAndReload = function (region) {
      selectedRegion = region;
      vm.gaUtil.sendGaEvent(vm.selectedBrand.key, 'Region Filter', region.labelDescription);
      vm.reload(false, false);
    };

    vm.isAnyDepartment = function (hierarchy) {
      return hierarchy.display === ANY_DEPARTMENT;
    };

    vm.getChartHeight = function () {
      var reportLength = (vm.report && vm.report.page) ? vm.report.page.length : vm.unfilteredData.length;
      return {'height': reportLength * 40 +'px'} ;
    };

    vm.lengthData = function () {
      return {brandsLength: (vm.unfilteredData.length > PageSize) ? PageSize : vm.unfilteredData.length};
    };

    function setBrandData(dataObject, other) {
      $timeout(function() {
        vm.report = _.defaultsDeep({ data : dataObject }, other, vm.report, {
          brandKey : reportData && reportData.brandKey,
          filteredText : vm.filteredText,
          currentPage : 1,
          pageSize : vm.pageSize,
          fn : {
            label : _.property('brandName'),
            value : _.property(vm.seriesFields[0]),
            color : ['#7C0A40'],
            valueLabel : function (item, index) {
              var value = vm.report.fn.value[0].apply(this, arguments);
              return (value * 100).toFixed(1) + '%';
            },
            filter : function (brand) {
              return brand.brandName.toLowerCase().indexOf(vm.report.filteredText.toLowerCase()) !== -1;
            },
            brandDataRange : function (item) {
              var maxPercentByCount = _.maxBy(item,'itemPercent').itemPercent;
              var maxPercentBySales = _.maxBy(item,'salesPercent').salesPercent;
              return Math.ceil(Math.max(maxPercentByCount,maxPercentBySales)*10)/10;
            }
          }
        });
      });
    };

    function setPriceData(other) {
      $timeout(function() {
        vm.pricePoint = _.defaultsDeep({ data :vm.pricePointData }, other, vm.pricePoint, {
          brandKey : reportData && reportData.brandKey,
          dontRank : true,
          fn : {
            label : function(item){
             var label;
              if(item.priceLow == -1) label = "$0 - $" + item.priceHigh;
              else if(item.priceHigh == -1) label = "$" + item.priceLow + "+";
              else label = "$"+item.priceLow + " - $" + item.priceHigh;
              return label;
            },
            value : _.property('quantity'),
            color : ['#7C0A40'],
            valueLabel : function (item, index) {
              var value = vm.pricePoint.fn.value.apply(this, arguments);
              return (value * 100).toFixed(1) + '%';
            }
          }
        });
      });
    };

    $scope.$watch('vm.report.data.length', function(length){
      vm.filteredCount = length;
    });

    vm.applyPagination = function(currentPage){
      setBrandData(vm.unfilteredData, {currentPage : currentPage});
    };

    setBrandData(vm.unfilteredData);
    setPriceData();

    vm.setFilteredText = function () {
      vm.currentPage = 1;
      setBrandData(vm.unfilteredData,{currentPage : vm.currentPage,filteredText : vm.filteredText});
    };

    vm.setValueSeries = function () {
      vm.currentPage = 1;
      setBrandData(vm.unfilteredData,{ currentPage : vm.currentPage, fn : { value : _.property(vm.selectedSeries) } })
    };

    vm.selectedBrandReload = function(selectedBrand){
      vm.selectedBrand = selectedBrand;
      vm.reload(true, true);
    };

    vm.reload = function(resetBrand , resetHierarchies) {
      CookieJar.set({name : 'tfc-insight-selected-brand',value : encodeURIComponent(_.toString(vm.selectedBrand.key))});

      if(!resetBrand && !resetHierarchies) {
        $state.go('.', { brandKey : vm.selectedBrand.key, timeFrame : vm.selectedTimeFrame,
          focusDepartment: vm.selectedFocusHierarchy.focusDepartment, focusCategory: vm.selectedFocusHierarchy.focusCategory,
          affinityDepartment: vm.selectedAffinityHierarchy.affinityDepartment,
          affinityCategory: vm.selectedAffinityHierarchy.affinityCategory, transaction: selectedTransaction && selectedTransaction.getLabel(),
          region: selectedRegion && selectedRegion.getLabel() }
          );
      }else if (!resetBrand && resetHierarchies) {
        $state.go('.', { brandKey : vm.selectedBrand.key, timeFrame : vm.selectedTimeFrame,
          focusDepartment: vm.selectedFocusHierarchy.focusDepartment, focusCategory: vm.selectedFocusHierarchy.focusCategory,
          affinityDepartment: null, affinityCategory: null , transaction: selectedTransaction && selectedTransaction.getLabel(),
          region: selectedRegion && selectedRegion.getLabel() }
          );
      }
      else {
        $state.go('.', { brandKey : vm.selectedBrand.key, timeFrame : null, focusDepartment: null, focusCategory: null, affinityDepartment: null, affinityCategory: null, transaction: null, region: null });
      }
    };

    vm.translateText = function(text){
      return translateFilter('reports.brand.' + text)
    };

    vm.getFilterSummaryText = function () {
      var pageName = 'brandAffinity';
      var params = {
        'quantity': vm.itemCount.quantity,
        'name': vm.selectedBrand.name,
        'activity': vm.activityRegionFilters && vm.activityRegionFilters.hasMultipleActivity() ? selectedTransaction && selectedTransaction.getLabel() : '',
        'region': selectedTransaction && selectedTransaction.hasMultipleRegion() ? selectedRegion && selectedRegion.labelDescription : '',
        'timeFrame': vm.translateText(vm.selectedTimeFrame)
      };
      return Filter.getFilterSummaryText(pageName, params);
    };

    vm.downloadReport = function(type){
      BrandAffinityReport.downloadReport(type, vm.selectedBrand.key, vm.selectedTimeFrame,
          vm.selectedFocusHierarchy.focusDepartment, vm.selectedFocusHierarchy.focusCategory,
          vm.selectedAffinityHierarchy.affinityDepartment, vm.selectedAffinityHierarchy.affinityCategory,
          selectedRegion && selectedRegion.getLabel(),
          selectedTransaction && selectedTransaction.getLabel(),
          vm.selectedSeries, vm.activityRegionFilters.hasMultipleActivity(),
          selectedTransaction && selectedTransaction.hasMultipleRegion());
    };

    function getHierarchy(department, category) {
      var hierarchy = _.join([department, category], "/");
      return hierarchy === '/' ? ANY_DEPARTMENT : hierarchy;
    }

    function doReload(selectedHierarchy, isFocusHierarchy) {
      var currStateHierarchy = isFocusHierarchy ?
          getHierarchy($stateParams.focusDepartment, $stateParams.focusCategory) :
          getHierarchy($stateParams.affinityDepartment, $stateParams.affinityCategory);

      return selectedHierarchy.display !== currStateHierarchy;
    }

    vm.onFocusHierarchyChange = function () {
      vm.gaUtil.sendGaEvent(vm.selectedBrand.key, 'Category Filter', vm.selectedFocusHierarchy.display);
      if(doReload(vm.selectedFocusHierarchy, true)) {
        vm.reload(false, true);
      }
    };

    vm.onAffinityHierarchyChange = function () {
      vm.gaUtil.sendGaEvent(vm.selectedBrand.key, 'Affinity Category Filter', vm.selectedAffinityHierarchy.display);
      if(doReload(vm.selectedAffinityHierarchy, false)) {
        vm.reload(false, false);
      }
    };
  }

})();
